import { useState, useCallback } from 'react';

var useToggle = function useToggle(initialValue) {
  if (initialValue === void 0) {
    initialValue = false;
  }

  var _useState = useState(initialValue),
      value = _useState[0],
      setValue = _useState[1];

  var toggle = useCallback(function (val) {
    if (typeof val === 'boolean' && val !== undefined) {
      setValue(val);
    } else {
      setValue(function (v) {
        return !v;
      });
    }
  }, []);
  return [value, toggle];
};

export default useToggle;